export default __webpack_public_path__ + "static/media/Foto30.baba8c14.png";